<template>
<div class="shipment-search">
	<div class="container ">
		<!-- Header -->
		<div class="page-header flex-center">
			<h1 class="page-title">{{ $t(`${pageTitle}`) }}</h1>
			<div class="page-header-right text-right ml-a">
				<a
					href="/admin/order-statistic"
					target="_blank"
					class="btn btn-light mr-2 d-inline"
				>
					<i class="bi bi-graph-up"></i>
					<span>Cek Statistic Order</span>
				</a>
				<!-- Date Filter -->
				<daterangepicker
					class="d-inline"
					:presets="filterDatePresets"
					:start="since"
					:end="until"
					:compact="isDeviceMobile"
					:disabled="disabledCalendar"
					@selected="setFilterDate"
					ref="datePicker"
				>
				</daterangepicker>
			</div>
		</div>

		<!-- Overviews -->
		<div class="submissions-summaries" v-if="routeActive === null">
			<overviews
				:overview="overview"
				:layout="'auto'"
				:items="overviewItems.primary"
				:capabilities="user.capabilities"
				:clickable="true"
				:source="'orders'"
				:is-fetching="isFetchingStatistic"
				@action="overviewAction"
				:exclude-board="'submission_count'"
			>
			</overviews>
		</div>

		<!-- Overviews -->
		<div class="submissions-summaries mb-3" v-if="routeActive === '3pl-pending'">
			<overviews
				:overview="overviewPending"
				:layout="'auto'"
				:items="overviewItems.primary"
				:capabilities="user.capabilities"
				:clickable="true"
				:source="'3pl-pending'"
				:is-fetching="isFetchingStatisticPending"
				@action="overviewAction"
			>
			</overviews>
		</div>

		<!-- Overviews -->
		<div class="submissions-summaries mb-3" v-if="routeActive === 'pending'">
			<overviews
				:overview="overviewPending"
				:layout="'auto'"
				:items="overviewItems.primary"
				:capabilities="user.capabilities"
				:clickable="true"
				:source="'pending'"
				:is-fetching="isFetchingStatisticPending"
				@action="overviewAction"
			>
			</overviews>
		</div>

		<!-- List -->
		<div class="main-table">
			<!-- <div class="flex-center mb-4">
				<h3 class="mb-2">Monitoring Orders</h3>
			</div> -->

			<!-- Table Actions -->
			<div class="row mb-2">
				<div class="col-md-4">
					<input
						type="text"
						class="form-control"
						placeholder="Order ID / Reference ID / Receipt Number : 1000, 1233, 4555, 0217192200030546, 001664310658"
						v-focus
						@input="onKeywordChange"
						v-model="keyword">
				</div>
				<div class="col d-flex align-items-center justify-content-end flex-wrap mt-2 mt-md-0">
					<!-- Customize Columns -->
					<button
						type="button"
						class="btn btn-light flex-center"
						@click="isShowCustomColumns = true"
					>
						<i class="material-icons">view_week</i>
						<span>Customize Columns</span>
					</button>
				</div>
			</div>

			<div class="row mb-4">
				<div class="col-md-6">
						<div class="row ml-1">
							<div class="col-md-6 p-0 m-0">
								<multiselect v-model="selectedSupplier"
									:show-labels="false"
									track-by="_id"
									label="label"
									placeholder="id/email/nama supplier"
									:options=optionSupplier
									:loading="isSearchingSupplier"
									@search-change="fetchDataSupplier"
									>
									<span slot="noResult">
										No options matching the query
									</span>
									<span slot="noOptions">
										No options available
									</span>
								</multiselect>
							</div>
							<div class="col-md-6 p-0 m-0 pl-3">
								<multiselect v-model="selectedSeller"
									:show-labels="false"
									track-by="_id"
									label="label"
									placeholder="email/nama seller"
									:options=optionSeller
									:loading="isSearchingSeller"
									@search-change="fetchDataSeller"
									>
									<span slot="noResult">
										No options matching the query
									</span>
									<span slot="noOptions">
										No options available
									</span>
								</multiselect>
							</div>
						</div>
				</div>
				<div class="col-md-6 d-flex align-items-center justify-content-end flex-wrap mt-2 mt-md-0">
					<!-- Filter -->
					<button type="button" class="btn btn-plain btn-sm" @click="clearFilter" v-if="isFilterOn">
						{{ $t('Clear Filter') }}
					</button>
					<button type="button" class="btn btn-light flex-center mr-2" @click="isShowFilter = true">
						<i class="material-icons mr-1">filter_list</i>Filter
					</button>
					<!-- Export -->
					<div class="dropdown">
						<button
							class="btn btn-light dropdown-toggle flex-center"
							data-toggle="dropdown"
							:class="{ 'is-loading': isExporting }"
						>
							<i class="material-icons">save_alt</i>
							<span class="mr-2">{{ $t('Export') }}</span>
						</button>
						<div class="dropdown-menu">
							<button
								type="button"
								class="dropdown-item"
								:class="{ 'is-loading': isExporting }"
								@click="exportOrder('order_new')"
								v-if="isUserCan('admin_monitoring_orders_action_export_new')">
								{{ $t('New Export Data Order') }}
							</button>
							<button
								type="button"
								class="dropdown-item"
								:class="{ 'is-loading': isExporting }"
								@click="exportOrder('order')">
								{{ $t('Export Data Order') }}
							</button>
							<!-- <button
								type="button"
								class="dropdown-item"
								:class="{ 'is-loading': isExporting }"
								@click="exportMonitoringOrders('ologi')">
								{{ $t('Export Ologi Format') }}
							</button> -->
						</div>
					</div>
				</div>
			</div>

			<div
				class="submissions-list table-responsive b-0"
				id="orders-list">
				<table
					class="table table-primary table-striped table-hover table--small submissions-list-table"
					id="orders-list-table">
					<thead>
						<tr>
							<th width="5%">No.</th>
							<th class="text-left" v-if="isShowColumn('id')">Order ID</th>
							<th class="text-left" v-if="isShowColumn('reference_id')">Reference ID</th>
							<th class="text-left" width="10%" v-if="isShowColumn('product_name')">Produk</th>
							<th class="text-left" v-if="isShowColumn('product_code')">Product SKU</th>
							<th class="text-left" v-if="isShowColumn('variations')">Variations</th>
							<th class="" v-if="isShowColumn('quantity')">Quantity</th>
							<th class="" v-if="isShowColumn('status')">Status</th>
							<th class="" v-if="isShowColumn('payment_status')">Status Pembayaran</th>
							<th class="" v-if="isShowColumn('payment_info')">Metode Pembayaran</th>
							<th class="text-left" v-if="isShowColumn('supplier')">Supplier</th>
							<th class="text-left" v-if="isShowColumn('seller')">Seller</th>
							<th class="text-left" v-if="isShowColumn('customer_name')">Customer</th>
							<th class="text-left" v-if="isShowColumn('customer_email')">Email</th>
							<th class="text-left" width="20%" v-if="isShowColumn('city')">Alamat</th>
							<th class="text-left" v-if="isShowColumn('courier')">Kurir</th>
							<th class="text-left" v-if="isShowColumn('receipt_number')">Receipt Number</th>
							<th class="text-left" v-if="isShowColumn('net_revenue')">Harga</th>
							<th class="text-left" v-if="isShowColumn('total_seller_price')">Harga Seller</th>
							<th class="" v-if="isShowColumn('shipping_cost')">Shipping Cost</th>
							<th class="" v-if="isShowColumn('cod_fee')">COD Fee</th>
							<th class="" v-if="isShowColumn('shipping_markup')">Shipping Markup</th>
							<th class="" v-if="isShowColumn('unique_code')">Kode Unik</th>
							<!-- <th class="">Other Cost</th> -->
							<th class="" v-if="isShowColumn('commission_fee')">Commission Fee</th>
							<th class="" v-if="isShowColumn('product_sourcing_fee')">Product Sourcing Fee</th>
							<th class="" v-if="isShowColumn('total_price')">Total</th>
							<!-- <th class="">Type</th> -->
							<!-- <th class="">Is Deleted</th> -->
							<!-- <th class="">Checkout URL</th>
							<th class="">Products</th>
							<th class="">Products Variations</th>
							<th class="text-left">Trackings</th> -->
							<th v-if="isShowColumn('date_ordered')">Ordered At</th>
							<th v-if="isShowColumn('date_created')">Created At</th>
							<th v-if="isShowColumn('date_processing')">Processing At</th>
							<th v-if="isShowColumn('date_manifested')">Manifested At</th>
							<th v-if="isShowColumn('date_delivered')">Delivered At</th>
							<th v-if="isShowColumn('date_returning')">{{ $t('Returning At') }}</th>
							<th v-if="isShowColumn('shipping.returned_at')">{{ $t('Returned At') }}</th>
							<th v-if="isShowColumn('date_return_completed')">Return Completed At</th>
							<th v-if="isShowColumn('date_cancelled')">Cancelled At</th>
							<th v-if="isShowColumn('date_refunded')">Refunded At</th>
							<th class="" v-if="isShowColumn('actions')">Actions</th>
							<th class="" v-if="isUserCan('admin_monitoring_orders_action_refund')">Refund Credit</th>
						</tr>
					</thead>
					<tbody>
						<orders-search-row
							v-for="(order, index) in (routeActive === null ? orders : orderPending)"
							:key="order._id"
							:index="index"
							:order="order"
							:columns="columns"
							@detail="showDetailOrder"
							@refund="showMarkRefund"
							@refundCredit="showMarkRefund"
							@showEvidence="showEvidence"
							@restore="onRestore"
							@track="onTrack"
							@showProduct="onShowProduct"
						/>
					</tbody>
				</table>

				<div
					class="list-empty table-empty text-center"
					v-if="routeActive === null && orders.length === 0 && !isSearching">
					<i class="material-icons mr-2">error_outline</i>
					<span>No Orders Found</span>
				</div>

				<div
					class="list-empty table-empty text-center"
					v-if="routeActive !== null && orderPending.length === 0 && !isSearching">
					<i class="material-icons mr-2">error_outline</i>
					<span>No Order Pending Found</span>
				</div>

				<!-- Loader -->
				<div
					class="my-3 p-3 text-center"
					v-if="isSearching">
					<div class="is-loading dark large"></div>
				</div>

				<div class="table-vertical-scroll hidden-sm" id="orders-list-vertical-scroll">
					<div class="table-vertical-scroll-content" id="orders-list-vertical-scroll-content"></div>
				</div>
			</div>
		</div>
	</div>

	<!-- Modals -->

	<!-- Shipping Tracking -->
	<modal-shipment-tracking
		:selectedSubmission="selectedSubmission"
		:isShowShippingTracking="isShowShippingTracking"
		@hide="hideShippingTracking"
	>
	</modal-shipment-tracking>

	<!-- Product View -->
	<modal-product-snapshot
		v-if="isShowModalProduct"
		:selectedSubmission="selectedSubmission"
		@close="hideShowProduct"
	/>

	<!-- Customize Columns -->
	<modal-customize-columns
		v-if="isShowCustomColumns"
		:categorized-columns="categorizedColumns"
		:is-admin="isAdmin"
		:is-saving-columns="isSavingColumns"
		:selected-columns="selectedColumns"
		@reset-columns="resetColumns"
		@apply-columns="applySelectedColumns"
		@close="isShowCustomColumns = false">
	</modal-customize-columns>

	<!-- Mark as Refunded -->
	<modal-confirm-refund
		v-if="isShowMarkRefund"
		:is-changing-status="isChangingStatus"
		:selected-submission="selectedSubmission"
		:is-refund-credit="isRefundCredit"
		@close="hideMarkRefund"
		@confirm="onRefunded">
	</modal-confirm-refund>

	<!-- Modal detail order -->
	<modal
		:class="{ 'is-printing': isPrinting }"
		class="order-details-modal"
		size="medium"
		@close="isShowDetailOrder = false"
		v-if="isShowDetailOrder && selectedSubmission"
	>
		<div slot="header">
			<h3><b>Order Details</b></h3>
		</div>
		<div slot="body">
			<invoice
				:store="user.store"
				:timezone="user.timezone"
				:order="selectedSubmission"
				:payment-visible="isPaymentVisible"
				:courier-visible="isCourierVisible"
			>
			</invoice>
		</div>
		<template slot="footer">
			<checkbox-toggle
				label="Show Payment Options"
				v-model="isPaymentVisible"
			>
			</checkbox-toggle>
			<checkbox-toggle
				:label="$t('_.hideCourier')"
				v-model="isCourierVisible"
			>
			</checkbox-toggle>
			<button class="btn btn-light ml-a" @click="isShowDetailOrder = false">
				{{ $t('Close') }}
			</button>
			<button
				class="btn btn-primary"
				@click="printInvoice"
				:class="{ 'is-printing': isPrinting }"
			>
				<i class="material-icons">cloud_download</i>
				<span>Download Invoice</span>
			</button>
		</template>
	</modal>

	<!-- Evidence Modal -->
	<evidence-modal
		v-if="isShowEvidenceModal"
		:evidence-url="evidenceUrl"
		:is-updating="isUpdatingEvidence"
		@close="isShowEvidenceModal = false"
		@update="updateEvidence"
	/>

	<!-- Modal Notice Export -->
	<modal-notice-export
		v-if="isShowNoticeExport"
		:filterDate="filterDate"
		@close="isShowNoticeExport = false">
	</modal-notice-export>

	<!-- Table Filter -->
	<modal
		class="table-filter-modal"
		size="large"
		@close="isShowFilter = false"
		v-if="isShowFilter"
	>
		<div slot="header">
			<h3>
				<i class="material-icons">filter_list</i>
				<span>{{ $t('Filter') }}</span>
			</h3>
		</div>
		<div slot="body">
			<div class="row">
				<!-- Date -->
				<div class="col-12 mt-2">
					<div class="row">
						<div class="col-lg-6">
							<label>
								<b>{{ $tc('Couriers') }} </b>
							</label>
							<!-- Courier Filter -->
							<multiselect
								class="form-control mr-3"
								style="width: auto;"
								placeholder="Select Courier"
								track-by="key"
								label="label"
								:options="shippingCouriersOptions"
								:show-labels="false"
								:allow-empty="false"
								v-model="selectedCourier"
								@select="onSelectCourier">
							</multiselect>
						</div>
						<div class="col-lg-6">
							<label>
								<b>{{ $tc('Payments') }} </b>
							</label>
							<!-- Payment Method Filter -->
							<multiselect
								class="form-control mr-3"
								style="width: auto;"
								placeholder="Select Status"
								track-by="key"
								label="label"
								:options="paymentMethodOptions"
								:show-labels="false"
								:allow-empty="false"
								v-model="selectedPaymentMethod"
								@select="onSelectPaymentMethod">
							</multiselect>
						</div>
						<!-- Return Date -->
						<div class="col-lg-12 mt-4">
							<label>
								<b>{{ $tc('Return Date') }} </b>
								<i
									class="material-icons info"
									v-tooltip="'Filter by returned date'"
									>info</i
								>
							</label>
							<div class="well mb-3">
								<div class="row">
									<!-- Return Date Since -->
									<div class="col-md-6">
										<div class="form-group">
											<label
												><b>{{ $tc('_.processingDateSince') }}</b></label
											>
											<input
												type="date"
												class="input form-control"
												placeholder="dd/mm/yyyy"
												v-model="filterReturnAtSince"
											/>
										</div>
									</div>
									<!-- Processing Date Until -->
									<div class="col-md-6">
										<div class="form-group">
											<label
												><b>{{ $tc('_.processingDateUntil') }}</b></label
											>
											<input
												type="date"
												class="input form-control"
												placeholder="dd/mm/yyyy"
												v-model="filterReturnAtUntil"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- Delivered Date -->
						<div class="col-lg-12 mt-4">
							<label>
								<b>{{ $tc('Delivered Date') }} </b>
								<i
									class="material-icons info"
									v-tooltip="'Filter by delivered date'"
									>info</i
								>
							</label>
							<div class="well mb-3">
								<div class="row">
									<!-- Return Date Since -->
									<div class="col-md-6">
										<div class="form-group">
											<label
												><b>{{ $tc('_.processingDateSince') }}</b></label
											>
											<input
												type="date"
												class="input form-control"
												placeholder="dd/mm/yyyy"
												v-model="filterDeliveredAtSince"
											/>
										</div>
									</div>
									<!-- Processing Date Until -->
									<div class="col-md-6">
										<div class="form-group">
											<label
												><b>{{ $tc('_.processingDateUntil') }}</b></label
											>
											<input
												type="date"
												class="input form-control"
												placeholder="dd/mm/yyyy"
												v-model="filterDeliveredAtUntil"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div slot="footer">
			<button
				type="button"
				class="btn btn-light"
				@click="isShowFilter = false"
			>
				{{ $t('Close') }}
			</button>
			<button type="button" class="btn btn-primary" @click="applyFilter">
				{{ $t('Apply filter') }}
			</button>
		</div>
	</modal>
</div>
</template>

<script>
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
import { mapGetters, mapActions } from 'vuex';
import {
	duplicateVar,
	isMobile,
	getDateRange,
	downloadFile,
	groupBy,
	getAxiosErrorMessage,
	makePDF,
	generateDateRange,
} from '@/lib/helper';
import adminApi from '@/api/admin';
import userApi from '@/api/user';
import { updateEvidence } from '@/api/submissions';
import OrdersSearchRow from '@/components/OrdersSearchRow.vue';
// import ShipmentTracking from '@/components/ShipmentTracking.vue';
// import Modal from '@/components/Modal.vue';
import EvidenceModal from '@/components/EvidenceModal.vue';
import ModalShipmentTracking from '@/components/ModalShipmentTracking.vue';
import ModalProductSnapshot from '@/components/ModalProductSnapshot.vue';
import ModalCustomizeColumns from '@/components/orders/ModalCustomizeColumns.vue';
import ModalConfirmRefund from '@/components/orders/ModalConfirmRefund.vue';
import ModalNoticeExport from '@/components/orders/ModalNoticeExport.vue';
import Daterangepicker from '@/components/Daterangepicker.vue';
import Overviews from '@/components/Overviews.vue';
import CheckboxToggle from '@/components/CheckboxToggle.vue';
import Modal from '@/components/Modal.vue';
import Invoice from '@/components/Invoice.vue';
import {
	defaultOrdersColumns,
	// shippingCouriers,
} from '@/lib/statics';
import statisticApi from '@/api/statistic';

const defaultFilterDate = getDateRange();
const defaultSelectedPaymentMethod = { key: 'all', label: 'All Payments' };
const defaultSelectedCourier = { key: 'all', label: 'All Couriers' };

export default {
	name: 'AdminOrders',
	props: {
		type: {
			type: String,
			default: 'shipment',
		},
	},
	components: {
		Modal,
		Invoice,
		CheckboxToggle,
		OrdersSearchRow,
		// ShipmentTracking,
		ModalShipmentTracking,
		ModalProductSnapshot,
		ModalCustomizeColumns,
		ModalConfirmRefund,
		EvidenceModal,
		Daterangepicker,
		Overviews,
		ModalNoticeExport,
		// Modal,
	},
	data() {
		return {
			page: 1,
			limit: 100,
			sort_by: 'created_at',
			sort: 'desc',
			isAll: false,
			keyword: '',
			keywordUser: '',
			since: null,
			until: null,
			isDeleted: null,
			sourceType: '',
			isDeviceMobile: false,
			isSearching: false,
			isFetchingStatistic: false,
			orders: [],
			isShowShippingTracking: false,
			isShowModalProduct: false,
			selectedSubmission: {},
			overviewItems: {
				primary: [],
			},
			selectedStatus: [],
			filterDeliveryStatus: '',
			filterIsManifested: false,
			filterDate: duplicateVar(defaultFilterDate),
			overview: {
				submission_count: 0,
				shipping_pending: 0,
				shipping_processed: 0,
				shipping_delivery: 0,
				shipping_completed: 0,
			},
			isExporting: false,
			paymentMethodOptions: [
				{ key: 'all', label: 'All Payments' },
				{ key: 'instant', label: 'Instant' },
				{ key: 'bank_transfer', label: 'Bank Transfer' },
				{ key: 'cod', label: 'COD' },
			],
			selectedPaymentMethod: defaultSelectedPaymentMethod,
			shippingCouriersOptions: [
				{ key: 'all', label: 'All Couriers' },
				{ key: 'oexpress', label: 'OExpress' },
				{ key: 'sap', label: 'SAP Express Courier' },
				{ key: 'jne', label: 'JNE Express' },
				{ key: 'jnt', label: 'J&T Express' },
				{ key: 'ninja', label: 'Ninja Xpress' },
				{ key: 'idexpress', label: 'ID Express' },
				{ key: 'paxel', label: 'Paxel' },
			],
			selectedCourier: defaultSelectedCourier,
			isShowCustomColumns: false,
			isSavingColumns: false,
			allOrdersColumns: defaultOrdersColumns,
			selectedColumns: [],
			isShowMarkRefund: false,
			isChangingStatus: false,
			isShowDetailOrder: false,
			isPaymentVisible: false,
			isCourierVisible: false,
			isPrinting: false,
			isShowEvidenceModal: false,
			evidenceUrl: '',
			isUpdatingEvidence: false,
			optionSupplier: [],
			selectedSupplier: null,
			optionSeller: [],
			selectedSeller: null,
			isSearchingSupplier: false,
			isSearchingSeller: false,
			isShowFilter: false,
			filterReturnAtSince: null,
			filterReturnAtUntil: null,
			filterDeliveredAtSince: null,
			filterDeliveredAtUntil: null,
			pendingType: null,
			pendingDays: null,
			returnStatus: null,
			orderPending: [],
			isFetchingStatisticPending: false,
			overviewPending: {},
			isRefundCredit: false,
			isShowNoticeExport: false,
		};
	},
	methods: {
		...mapActions({
			fetchUser: 'fetchUser',
		}),
		generateDateRange,
		clearFilter() {
			this.selectedSeller = null;
			this.selectedSupplier = null;
			this.selectedPaymentMethod = null;
			this.selectedCourier = null;
			this.filterReturnAtSince = null;
			this.filterReturnAtUntil = null;
			this.filterDeliveredAtSince = null;
			this.filterDeliveredAtUntil = null;
			this.filterDate = getDateRange();

			this.fetchData(true);
			this.fetchOverviews();
		},
		printInvoice() {
			this.isPrinting = true;
			const orderId = this.selectedSubmission.order_id;
			const timestamp = new Date().getTime();
			const name = `Invoice-${orderId}-${timestamp}`;
			const callback = () => {
				this.isPrinting = false;
			};
			setTimeout(() => {
				makePDF(document, 'invoice', html2canvas, jsPDF, name, callback);
			}, 300);
		},
		showDetailOrder(submission, event) {
			event.preventDefault();

			this.selectedSubmission = submission;
			this.isShowDetailOrder = true;
		},
		resetItems() {
			this.orders = [];
			this.orderPending = [];
			this.isAll = false;
			this.page = 1;
		},
		fetchDataOrder(reset = true) {
			// if (this.keyword.trim() === '') {
			// 	return;
			// }
			this.isSearching = true;

			if (reset) {
				this.resetItems();
			}

			const params = this.fetchParams;

			const callback = (response) => {
				const orders = response.data;
				// this.orders = orders;
				this.isSearching = false;

				if (orders.length > 0) {
					this.page++;
					this.orders = this.orders.concat(orders);
				} else {
					this.isAll = true;
				}
				this.optionSeller = [];
				this.optionSupplier = [];
				this.isSearchingSupplier = false;
				this.isSearchingSeller = false;
			};
			const errorCallback = () => {
				this.isSearching = false;
			};
			adminApi.searchOrders(params, callback, errorCallback);
		},
		fetchDataPending(reset = true) {
			this.isSearching = true;

			if (reset) {
				this.resetItems();
			}

			const params = this.fetchParams;

			const callback = (response) => {
				const orders = response.data;
				this.isSearching = false;

				if (orders.length > 0) {
					this.page++;
					this.orderPending = this.orderPending.concat(orders);
				} else {
					this.isAll = true;
				}
				this.optionSeller = [];
				this.optionSupplier = [];
				this.isSearchingSupplier = false;
				this.isSearchingSeller = false;
			};
			const errorCallback = () => {
				this.isSearching = false;
			};
			adminApi.searchOrders(params, callback, errorCallback);
		},
		fetchData(reset = true) {
			if (this.routeActive === null) {
				this.fetchDataOrder(reset);
			} else {
				this.fetchDataPending(reset);
			}
		},
		fetchDataSupplier(query) {
			this.isSearchingSupplier = true;

			const params = {
				keyword: query,
				role: 'owner',
				owner_type: 'supplier',
			};

			const callback = (response) => {
				this.optionSupplier = response.data;
				this.isSearchingSupplier = false;
			};
			const errorCallback = () => {
				this.isSearchingSupplier = false;
			};

			this.ooDelay(() => {
				if (query !== '') {
					adminApi.searchUser(params, callback, errorCallback);
				}
			}, 1000);
		},
		fetchDataSeller(query) {
			this.isSearchingSeller = true;

			const params = {
				keyword: query,
				role: 'owner',
				owner_type: 'dropshipper',
			};

			const callback = (response) => {
				this.optionSeller = response.data;
				this.isSearchingSeller = false;
			};
			const errorCallback = () => {
				this.isSearchingSeller = false;
			};

			this.ooDelay(() => {
				if (query !== '') {
					adminApi.searchUser(params, callback, errorCallback);
				}
			}, 1000);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 100;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isSearching && !this.isAll) {
					this.fetchData(false);
				}
			}
		},
		onKeywordChange() {
			const self = this;
			this.ooDelay(() => {
				const keyword = this.keyword ? this.keyword.trim() : '';
				const query = duplicateVar(this.$route.query);
				if (keyword !== '') {
					query.q = keyword;
				} else {
					delete query.q;
				}
				const params = { query };
				this.$router.push(params);
				self.fetchData();
			}, 1000);
		},
		onKeywordUserChange() {
			const self = this;
			this.ooDelay(() => {
				const keywordUser = this.keywordUser ? this.keywordUser.trim() : '';
				const query = duplicateVar(this.$route.query);
				if (keywordUser !== '') {
					query.u = keywordUser;
				} else {
					delete query.u;
				}
				const params = { query };
				this.$router.push(params);
				self.applyFilter();
			}, 1000);
		},
		checkListTable() {
			const ordersList = document.getElementById('orders-list');
			if (ordersList) {
				const ordersListVerticalScroll = document.getElementById('orders-list-vertical-scroll');
				const documentHeight = document.documentElement.clientHeight;
				const scrollTop = document.documentElement.scrollTop;
				const ordersListHeight = ordersList.offsetHeight;
				const offsetTop = ordersList.offsetTop;
				const offsetBottom = offsetTop + ordersListHeight;
				const scrollBottom = offsetBottom - scrollTop;
				const topTreshold = 100;
				const scrollTreshold = offsetTop - (documentHeight - topTreshold);
				const display = scrollTop >= scrollTreshold && scrollBottom >= documentHeight ? 'block' : 'none';
				ordersListVerticalScroll.style.display = display;
			}
		},
		onDocumentScroll(event) {
			if (event.target === document) {
				this.checkListTable();
			} else if (event.target.id === 'orders-list') {
				const element = event.target;
				const scrollLeft = element.scrollLeft;
				const ordersListVerticalScroll = document.getElementById('orders-list-vertical-scroll');
				ordersListVerticalScroll.scrollLeft = scrollLeft;
			} else if (event.target.id === 'orders-list-vertical-scroll') {
				const element = event.target;
				const scrollLeft = element.scrollLeft;
				const ordersList = document.getElementById('orders-list');
				ordersList.scrollLeft = scrollLeft;
			}
		},
		setVerticalScroll() {
			const ordersList = document.getElementById('orders-list');
			if (ordersList) {
				const ordersListTable = document.getElementById('orders-list-table');
				const ordersListVerticalScroll = document.getElementById('orders-list-vertical-scroll');
				const ordersListVerticalScrollContent = document.getElementById('orders-list-vertical-scroll-content');
				const listWidth = ordersList.offsetWidth;
				const listLeft = ordersList.offsetLeft;
				const tableWidth = ordersListTable.offsetWidth;
				ordersListVerticalScroll.style.width = `${listWidth}px`;
				ordersListVerticalScroll.style.left = `${listLeft}px`;
				ordersListVerticalScrollContent.style.width = `${tableWidth}px`;
			}
		},
		onRefund(order) {
			const index = this.orders.findIndex(({ _id }) => _id === order._id);
			if (index !== -1) {
				order.payment.shipping_deducted = false;
				this.$set(this.orders, index, order);
			}
		},
		onRestore(orderId) {
			// eslint-disable-next-line
			const index = this.orders.findIndex(({ order_id }) => order_id === orderId);
			if (index !== -1) {
				const order = this.orders[index];
				order.is_deleted = false;
				this.$set(this.orders, index, order);
			}
		},
		onTrack(order) {
			this.isShowShippingTracking = true;
			this.selectedSubmission = order;
		},
		hideShippingTracking() {
			this.isShowShippingTracking = false;
			this.selectedSubmission = {};
		},
		onShowProduct(order) {
			this.isShowModalProduct = true;
			this.selectedSubmission = order;
		},
		hideShowProduct() {
			this.isShowModalProduct = false;
			this.selectedSubmission = {};
		},
		resetFilter() {
			this.selectedStatus = [];
			this.filterDeliveryStatus = '';
			this.filterIsManifested = false;
			this.isDeleted = null;
			this.sourceType = '';
			this.sourceType = '';
			this.pendingType = null;
			this.pendingDays = null;
			this.returnStatus = null;
		},
		overviewAction(key) {
			this.resetFilter();
			if (key === 'shipping_pending') {
				this.isDeleted = false;
				this.selectedStatus = ['Pending'];
				this.filterDeliveryStatus = '';
				this.filterIsManifested = false;
			} else if (key === 'shipping_processed') {
				this.isDeleted = false;
				this.selectedStatus = ['Processing'];
				this.filterDeliveryStatus = 'processing';
				this.filterIsManifested = false;
			} else if (key === 'shipping_delivery') {
				this.isDeleted = false;
				this.selectedStatus = ['Processing'];
				this.filterDeliveryStatus = 'processing';
				this.filterIsManifested = true;
			} else if (key === 'shipping_completed') {
				this.isDeleted = false;
				this.selectedStatus = ['Completed'];
				this.filterDeliveryStatus = 'delivered';
				this.filterIsManifested = true;
			} else if (key === 'shipping_return_to_shipper') {
				this.isDeleted = false;
				this.selectedStatus = ['Completed', 'Processing'];
				this.filterDeliveryStatus = 'cancelled';
				this.filterIsManifested = true;
				this.returnStatus = 'delivered';
			} else if (key === 'shipping_cancelled') {
				this.isDeleted = true;
				this.sourceType = 'orderonline';
			} else if (key === 'shipping_refunded') {
				this.selectedStatus = ['Refunded'];
			} else if (key === 'submission_count') {
				this.resetFilter();
			} else if (key === 'supplier_pending_h1') {
				this.pendingType = 'supplier';
				this.pendingDays = 1;
				this.selectedStatus = ['pending'];
				this.isDeleted = false;
			} else if (key === 'supplier_pending_h2') {
				this.pendingType = 'supplier';
				this.pendingDays = 2;
				this.selectedStatus = ['pending'];
				this.isDeleted = false;
			} else if (key === 'supplier_pending_h3') {
				this.pendingType = 'supplier';
				this.pendingDays = 3;
				this.selectedStatus = ['pending'];
				this.isDeleted = false;
			} else if (key === 'supplier_pending_h4') {
				this.pendingType = 'supplier';
				this.pendingDays = 4;
				this.selectedStatus = ['pending'];
				this.isDeleted = false;
			} else if (key === 'third_party_logistic_pending_h1') {
				this.pendingType = 'third_party_logistic';
				this.pendingDays = 1;
				this.isDeleted = false;
				this.filterIsManifested = false;
			} else if (key === 'third_party_logistic_pending_h2') {
				this.pendingType = 'third_party_logistic';
				this.pendingDays = 2;
				this.filterIsManifested = false;
				this.isDeleted = false;
			} else if (key === 'third_party_logistic_pending_h3') {
				this.pendingType = 'third_party_logistic';
				this.pendingDays = 3;
				this.filterIsManifested = false;
				this.isDeleted = false;
			} else if (key === 'third_party_logistic_pending_h4') {
				this.pendingType = 'third_party_logistic';
				this.pendingDays = 4;
				this.filterIsManifested = false;
				this.isDeleted = false;
			} else if (key === 'shipping_process_return') {
				this.returnStatus = 'processing';
				this.filterIsManifested = false;
				this.isDeleted = false;
			} else if (key === 'shipping_return_completed') {
				this.returnStatus = 'completed';
				this.filterIsManifested = false;
				this.isDeleted = false;
			} else if (key === 'shipping_return_broken') {
				this.returnStatus = 'broken';
				this.filterIsManifested = false;
				this.isDeleted = false;
			}

			this.fetchData();
		},
		setFilterDate(filterDate) {
			this.filterDate = filterDate;
			const since = this.moment(filterDate.start).format('YYYY-MM-DD');
			const until = this.moment(filterDate.end).format('YYYY-MM-DD');
			const query = duplicateVar(this.$route.query);
			query.since = since;
			query.until = until;
			const params = { query };
			this.$router.push(params);
			this.applyFilter();
		},
		fetchOverviewsOrder() {
			this.isFetchingStatistic = true;
			const params = this.fetchParams;

			const callback = (response) => {
				const statistic = response.data;
				this.overview = statistic;
				this.isFetchingStatistic = false;
			};
			const errorCallback = (e) => {
				console.log(e);
				this.isFetchingStatistic = false;
			};

			adminApi.orderStatistic(params, callback, errorCallback);
		},
		fetchOverviewsPending() {
			this.isFetchingStatisticPending = true;
			const params = this.fetchParams;

			const callback = (response) => {
				const statistic = response.data;
				this.overviewPending = statistic;
				this.isFetchingStatisticPending = false;
			};
			const errorCallback = (e) => {
				console.log(e);
				this.isFetchingStatisticPending = false;
			};

			statisticApi.calculateStatisticOrder(params, callback, errorCallback);
		},
		fetchOverviews() {
			if (this.routeActive !== null) {
				this.fetchOverviewsPending();
			} else {
				this.fetchOverviewsOrder();
			}
		},
		applyFilter() {
			this.fetchOverviews();
			this.fetchData();
			this.isShowFilter = false;
		},
		exportMonitoringOrdersNew(type) {
			this.isExporting = true;
			const params = this.fetchParams;
			params.type = type;

			const callback = () => {
				this.$notify({
					group: 'app',
					type: 'info',
					title: '<a class="disabled-style-link text-white" href="/admin/export-page">Data export is being processed</a>',
					text: '<a class="disabled-style-link text-white" href="/admin/export-page">Your report is being processed For more details, please visit</a>',
					duration: 15000,
				});
				this.isExporting = false;
			};
			const errorCallback = () => {
				this.isExporting = false;
			};
			adminApi.exportSubmissionQueue(params, callback, errorCallback);
		},
		exportMonitoringOrders(type) {
			this.isExporting = true;
			const params = this.fetchParams;
			params.type = type;

			const callback = (response) => {
				const url = response.data;
				if (url && url !== '') {
					downloadFile(url);
				} else {
					const message = 'No transactions with the selected type';
					this.$notify({
						group: 'app',
						type: 'warn',
						title: 'Export Transactions',
						text: message,
					});
				}
				this.isExporting = false;
			};
			const errorCallback = () => {
				this.isExporting = false;
			};
			adminApi.exportMonitoringOrders(params, callback, errorCallback);
		},
		onSelectPaymentMethod(optionValue) {
			this.selectedPaymentMethod = optionValue;
		},
		onSelectCourier(optionValue) {
			this.selectedCourier = optionValue;
		},
		isShowColumn(key) {
			return this.columns.includes(key);
		},
		initColumns() {
			this.selectedColumns = duplicateVar(this.columns);
		},
		resetColumns() {
			this.initColumns();
			this.isShowCustomColumns = false;
		},
		applySelectedColumns(value) {
			this.selectedColumns = value;
			this.applyColumns();
		},
		applyColumns() {
			const columns = duplicateVar(this.selectedColumns);
			const columnsString = columns.join(',');
			const query = duplicateVar(this.$route.query);
			query.columns = columnsString;
			this.$router.push({ name: 'adminOrders', query });
			this.isShowCustomColumns = false;
			const callback = () => this.fetchUser();
			userApi.udpateOrdersColumns(columns, callback);
		},
		showMarkRefund(submission, withCredit = false) {
			this.selectedSubmission = submission;
			this.isShowMarkRefund = true;

			if (withCredit) {
				this.isRefundCredit = true;
			}
		},
		showEvidence(submission) {
			this.selectedSubmission = submission;
			this.evidenceUrl = submission?.shipping?.evidence_url ?? '';
			this.isShowEvidenceModal = true;
		},
		updateSubmission(submission) {
			const index = this.orders.findIndex(currSubmission => currSubmission._id === submission._id);
			if (index !== -1) {
				this.orders[index] = submission;
			}
		},
		updateEvidence(evidenceUrl) {
			this.isUpdatingEvidence = true;

			const submissionId = this.selectedSubmission._id;

			const payload = {
				submission_id: submissionId,
				evidence_url: evidenceUrl,
			};

			const callback = (response) => {
				const message = response?.message ?? 'Success';

				this.isUpdatingEvidence = false;
				this.isShowEvidenceModal = false;

				const currentSubmission = duplicateVar(this.selectedSubmission);
				const currentShipping = currentSubmission.shipping;
				currentShipping.evidence_url = evidenceUrl;
				currentSubmission.shipping = currentShipping;
				this.updateSubmission(currentSubmission);

				this.$notify({
					group: 'orders',
					title: 'Update Evidence',
					text: message,
					type: 'success',
				});
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.isUpdatingEvidence = false;
				this.$notify({
					group: 'orders',
					title: 'Update Evidence',
					text: message,
					type: 'error',
				});
			};

			updateEvidence(payload, callback, errorCallback);
		},
		hideMarkRefund() {
			this.isShowMarkRefund = false;
			this.selectedSubmission = null;
			this.isRefundCredit = false;
		},
		onRefunded(submission) {
			this.setStatus(submission, 'refunded');
		},
		setStatus(submission, status) {
			this.isChangingStatus = true;

			const submissionId = submission._id;
			const params = { status };

			if (this.isRefundCredit) {
				params.is_refund_credit = true;
			}

			const callback = () => {
				const payload = {
					id: submissionId,
					status,
				};

				this.changeStatus(payload);

				this.isChangingStatus = false;
				this.hideMarkRefund();
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.isChangingStatus = false;
				this.$notify({
					group: 'orders',
					title: 'Order Status',
					text: message,
					type: 'warn',
				});
			};

			adminApi.setStatus(submissionId, params, callback, errorCallback);
		},
		changeStatus(payload) {
			const { id, status } = payload;
			const index = this.orders.findIndex(item => item._id === id);
			if (index !== -1) {
				this.orders[index].status = status;
				if (status === 'refunded') {
					const paymentMethod = this.orders[index]?.payment?.method ?? 'bank_transfer';
					const paymentStatus = this.orders[index]?.payment?.status;
					if (paymentMethod !== 'instant' && paymentStatus) { // don't update payment status if payment method is instant
						this.orders[index].payment.status = 'unpaid';
						this.orders[index].paid_at = null;
					}
				}
			}
		},
		initPrimaryOverview() {
			if (this.routeActive === null) {
				this.overviewItems.primary = [
					'submission_count',
					'shipping_pending',
					'shipping_processed',
					'shipping_delivery',
					'shipping_completed',
					// 'shipping_cancelled',
				];
				this.resetFilter();
			}

			if (this.routeActive === 'pending') {
				this.overviewItems.primary = [
					'supplier_pending_h1',
					'supplier_pending_h2',
					'supplier_pending_h3',
					'supplier_pending_h4',
				];
				this.pendingType = 'supplier';
				this.pendingDays = 1;
				this.selectedStatus = ['pending'];
				this.isDeleted = false;
			}

			if (this.routeActive === '3pl-pending') {
				this.overviewItems.primary = [
					'third_party_logistic_pending_h1',
					'third_party_logistic_pending_h2',
					'third_party_logistic_pending_h3',
					'third_party_logistic_pending_h4',
				];
				this.pendingType = 'third_party_logistic';
				this.pendingDays = 1;
				this.isDeleted = false;
				this.filterIsManifested = false;
			}
		},
		exportOrder(type) {
			const since = this.moment(this.filterDate.start);
			const until = this.moment(this.filterDate.end);

			const diffInDays = until.diff(since, 'days');

			if (diffInDays <= 90) {
				if (type === 'order_new') {
					this.exportMonitoringOrdersNew('order');
				} else {
					this.exportMonitoringOrders('order');
				}
			} else {
				this.isShowNoticeExport = true;
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			// overview: 'overview',
			filterDatePresets: 'filterDatePresets',
			isAdmin: 'isAdmin',
			isUserCan: 'isUserCan',
			ordersColumns: 'ordersColumns',
		}),
		isFilterOn() {
			return this.selectedSeller || this.selectedSupplier || this.selectedCourier || this.selectedPaymentMethod || this.filterReturnAtSince || this.filterReturnAtUntil || this.filterDeliveredAtSince || this.filterDeliveredAtUntil;
		},
		categorizedColumns() {
			return groupBy(this.allOrdersColumns, 'category');
		},
		columnsQuery() {
			return this.$route.query.columns;
		},
		columns() {
			const columnsArray = this.columnsQuery
				? this.columnsQuery.split(',')
				: this.ordersColumns;
			return columnsArray;
		},
		histories() {
			return this.selectedSubmission.shipping.trackings && this.selectedSubmission.shipping.trackings.history ? duplicateVar(this.selectedSubmission.shipping.trackings.history).reverse() : [];
		},
		fetchParams() {
			const dateFormat = 'YYYY-MM-DD';
			const startDate = this.moment(this.filterDate.start).format(dateFormat);
			const endDate = this.moment(this.filterDate.end).format(dateFormat);
			const keyword = this.keyword.trim();
			const keywordUser = this.keywordUser.trim();
			const status = this.selectedStatus.join(',').toLowerCase();
			const filterDeliveryStatus = this.filterDeliveryStatus;
			const filterIsManifested = this.filterIsManifested;
			const paymentMethod = this.selectedPaymentMethod ? this.selectedPaymentMethod.key : 'all';
			const courier = this.selectedCourier ? this.selectedCourier.key : 'all';
			const isDeleted = this.isDeleted;
			const sourceType = this.sourceType;
			const columns = this.columns.toString();
			const selectedSupplier = this.selectedSupplier?._id ?? '';
			const selectedSeller = this.selectedSeller?._id ?? '';
			const filterReturnAtSince = this.filterReturnAtSince;
			const filterReturnAtUntil = this.filterReturnAtUntil;
			const filterDeliveredAtSince = this.filterDeliveredAtSince;
			const filterDeliveredAtUntil = this.filterDeliveredAtUntil;
			const pendingType = this.pendingType;
			const pendingDays = this.pendingDays;
			const returnStatus = this.returnStatus;

			const params = {
				page: this.page,
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				since: startDate,
				until: endDate,
				keyword,
			};

			if (filterReturnAtSince) {
				params.return_at_since = filterReturnAtSince;
			}

			if (filterReturnAtUntil) {
				params.return_at_until = filterReturnAtUntil;
			}

			if (filterDeliveredAtSince) {
				params.delivered_at_since = filterDeliveredAtSince;
			}

			if (filterDeliveredAtUntil) {
				params.delivered_at_until = filterDeliveredAtUntil;
			}

			if (selectedSupplier) {
				params.supplier = selectedSupplier;
			}

			if (selectedSeller) {
				params.seller = selectedSeller;
			}

			if (status !== '') {
				params.status = status;
			}

			if (filterDeliveryStatus !== '') {
				params.delivery_status = filterDeliveryStatus;
			}

			if (filterIsManifested !== '') {
				params.is_manifested = filterIsManifested;
			}

			if (keywordUser !== '') {
				params.keyword_user = keywordUser;
			}

			if (paymentMethod !== 'all') {
				params.payment_method = paymentMethod;
			}

			if (courier !== 'all') {
				params.courier = courier;
			}

			if (isDeleted !== null) {
				params.is_deleted = isDeleted;
			}

			if (sourceType !== '') {
				params.source_type = sourceType;
			}

			if (columns !== '') {
				params.columns = columns;
			}

			if (pendingType) {
				params.pending_type = pendingType;
			}

			if (pendingDays) {
				params.pending_days = pendingDays;
			}

			if (returnStatus) {
				params.return_status = returnStatus;
			}

			return params;
		},
		keywordQuery() {
			const keyword = this.$route?.query?.q ?? '';
			return keyword;
		},
		disabledCalendar() {
			return this.filterReturnAtSince != null && this.filterReturnAtUntil != null && this.filterDeliveredAtSince != null && this.filterDeliveredAtUntil != null;
		},
		routeActive() {
			return this.$route?.params?.type ?? null;
		},
		pageTitle() {
			this.initPrimaryOverview();
			let pageTitle = 'Monitoring Orders';

			if (this.routeActive === '3pl-pending') {
				pageTitle = '3PL Pending Order';
			}

			if (this.routeActive === 'pending') {
				pageTitle = 'Supplier Pending Order';
			}

			return pageTitle;
		},
	},
	watch: {
		user(user) {
			if (user) {
				this.initColumns();
			}
		},
		selectedSupplier() {
			if (this.selectedSupplier) {
				this.fetchData(true);
				this.fetchOverviews();
			}
		},
		selectedSeller() {
			if (this.selectedSeller) {
				this.fetchData(true);
				this.fetchOverviews();
			}
		},
		filterReturnAtSince() {
			this.filterDate.start = new Date(this.filterReturnAtSince);
		},
		filterReturnAtUntil() {
			this.filterDate.end = new Date(this.filterReturnAtUntil);
		},
		filterDeliveredAtSince() {
			this.filterDate.start = new Date(this.filterDeliveredAtSince);
		},
		filterDeliveredAtUntil() {
			this.filterDate.end = new Date(this.filterDeliveredAtUntil);
		},
		routeActive() {
			this.resetFilter();
			if (!!this.routeActive === false) {
				this.fetchData(true);
				this.fetchOverviews();
			}

			if (this.routeActive === 'pending') {
				this.pendingType = 'supplier';
				this.pendingDays = 1;
				this.isDeleted = false;
				this.selectedStatus = ['pending'];
				this.fetchData(true);
				this.fetchOverviews();
			}

			if (this.routeActive === '3pl-pending') {
				this.pendingType = 'third_party_logistic';
				this.pendingDays = 1;
				this.isDeleted = false;
				this.filterIsManifested = false;
				this.fetchData(true);
				this.fetchOverviews();
			}
		},
	},
	created() {
		this.isDeviceMobile = isMobile();
		document.addEventListener('scroll', this.onDocumentScroll, true);
		window.addEventListener('resize', this.checkListTable, true);
		// if (this.keywordQuery && this.keywordQuery !== '') {
		// 	this.keyword = duplicateVar(this.keywordQuery);
		// 	this.fetchData();
		// }
		// On Scroll Bottom
		window.addEventListener('scroll', this.handleScroll);
		this.initColumns();
		this.initPrimaryOverview();
		this.fetchData();
		this.fetchOverviews();
	},
	destroyed() {
		document.removeEventListener('scroll', this.onDocumentScroll, true);
		window.removeEventListener('resize', this.checkListTable, true);
		window.removeEventListener('scroll', this.handleScroll);
	},
	updated() {
		this.$nextTick(() => {
			this.setVerticalScroll();
			this.checkListTable();
		});
	},
};
</script>

<style scoped>
.disabled-style-link {
	text-decoration: none;
}
</style>
